function htmlSetIframeLoadingAttributes(html, value) {
  return html.replace(/<iframe/g, `<iframe loading="${value}" `);
}

export default htmlSetIframeLoadingAttributes;
